import React from 'react'
import { Grid, Column } from 'goustouicomponents'
import PropTypes from 'prop-types'

import { Button, ButtonColorVariant } from '@gousto-internal/citrus-react'
import { Section } from '../components/Section'
import { OrderABox } from './sections/OrderABox'
import { orderABoxSection, resubscribeSection } from '../subscriptionsSectionsContent'
import { Resubscribe } from '../Resubscribe'
import { LegacyResubscribe } from './sections/LegacyResubscribe'
import { isModernResubscribeEnabled } from '../isModernResubscribeEnabled'

export const PausedSubscription = ({ accessToken, showResubscribe, setShowResubscribe }) => {
  const disableLegacyResubscribeView = isModernResubscribeEnabled()
  const onResubscribeBackClick = () => setShowResubscribe(false)

  if (showResubscribe) {
    return (
      <Resubscribe data-testid="resubscribe-screen" accessToken={accessToken} onBackClick={onResubscribeBackClick} />
    )
  }

  return (
    <Grid>
      {!disableLegacyResubscribeView && (
      <Column
        smallScreen={12}
        mediumScreen={6}
        largeScreen={6}
        hasPaddingSmallScreen={false}
      >
        <LegacyResubscribe accessToken={accessToken} />
      </Column>
      )}

      {disableLegacyResubscribeView && (
      <Column
        smallScreen={12}
        mediumScreen={6}
        largeScreen={6}
        hasPaddingSmallScreen={false}
      >
        <Section
          title={resubscribeSection.title}
          subTitle={resubscribeSection.subTitle}
          testingSelector={resubscribeSection.testingSelector}
        >
          <Button
            data-testid="resubscribe-cta"
            onClick={() => setShowResubscribe(true)}
            colorVariant={ButtonColorVariant.Primary}
            width="100%"
            id="resubscribe-cta"
          >Reactivate subscription
          </Button>
        </Section>
      </Column>
      )}
      <Column
        smallScreen={12}
        mediumScreen={6}
        largeScreen={6}
        hasPaddingSmallScreen={false}
      >
        <Section
          title={orderABoxSection.title}
          subTitle={orderABoxSection.subTitle}
          testingSelector={orderABoxSection.testingSelector}
        >
          <OrderABox />
        </Section>
      </Column>
    </Grid>

  )
}

PausedSubscription.propTypes = {
  accessToken: PropTypes.string.isRequired,
  showResubscribe: PropTypes.bool.isRequired,
  setShowResubscribe: PropTypes.func.isRequired,
}
